if (!String.prototype.nl2br) {
    String.prototype.nl2br = function (is_xhtml) {
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return this.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
    };
}
if (!String.prototype.nbsp) {
    String.prototype.nbsp = function () {
        let text = this.replace(/\s([:!\?;%»])/g, '&nbsp;$1');
        text = text.replace(/([«])\s+/g, '$1&nbsp;');
        text = text.replace(/(\d)\s+(\w)/g, '$1&nbsp;$2');
        return text;
    };
}
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}

if (!String.prototype.numberWithspace) {
    String.prototype.numberWithspace = function () {
        return this.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
}

if (!String.prototype.removeAccents) {
    String.prototype.removeAccents = function () {
        return this.normalize("NFD").replace(/\p{Diacritic}/gu, "");
    }
}

function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return false;
}

if (/MSIE|Trident/.test(navigator.userAgent))
    document.querySelector('html').className = 'isIE';

(function () {
    new SiteApp();
})(jQuery);
